import { render, staticRenderFns } from "./ms-input.vue?vue&type=template&id=87b36a6c&"
import script from "./ms-input.vue?vue&type=script&lang=ts&"
export * from "./ms-input.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports